import { envValue, isTruthyEnv } from '@helpers/envHelpers';

/** Whether the SSO login page should be shown instead of username/password. */
export function isExternalLoginEnabled(): boolean {
  if (isTruthyEnv('VITE_AUTH0_ENABLED')) {
    return true;
  }

  return isTruthyEnv('VITE_AZURE_LOGIN_ENABLED');
}

/**
 * Whether Azure Entra ID login is active.
 * Softys: follows VITE_AUTH0_ENABLED (unchanged).
 * Azure-only clients (e.g. Mall Plaza): set VITE_AZURE_LOGIN_ENABLED=true.
 */
export function isAzureLoginEnabled(): boolean {
  if (envValue('VITE_AZURE_LOGIN_ENABLED') !== undefined) {
    return isTruthyEnv('VITE_AZURE_LOGIN_ENABLED');
  }

  return isTruthyEnv('VITE_AUTH0_ENABLED');
}

/**
 * Whether the generic OIDC login is active for this host.
 *
 * Deliberately outside isExternalLoginEnabled: Auth0 and Azure replace the
 * username and password form, but OIDC sits next to it. Clients using it keep
 * users outside their corporate directory — contractor staff, mostly — who
 * still need to sign in with a password.
 */
export function isOidcLoginEnabled(): boolean {
  return isTruthyEnv('VITE_OIDC_ENABLED');
}
